import { BaseFirestoreService } from "../FirestoreService";
import { USER_REVIEWS_COLLECTION, UserReview, USERS_COLLECTION } from "../../db/user";
import { FirestoreDatabase as Database } from "../../db/common";

/**
 * Shared User Reviews Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class UserReviewService extends BaseFirestoreService<UserReview> {
    constructor(protected db: Database, protected userId: string) {
        super(db);
    }
    protected getCollectionPath(): string {
        return `${USERS_COLLECTION}/${this.userId}/${USER_REVIEWS_COLLECTION}`;
    }
}
